
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.431 13.558H18.18l-.844.95-2.723 3.07-.844.95H5.62l.823-.96.39-.454.824-.96H3.912c-.686 0-1.245.58-1.245 1.277v2.701c0 .707.559 1.277 1.245 1.277H18.285c.685 0 1.625-.432 2.078-.95l2.174-2.469 3.894-4.432z","fill":"#004E91"}}),_c('path',{attrs:{"d":"M28.088 10.677c.686 0 1.245.58 1.245 1.277v2.701c0 .708-.56 1.277-1.245 1.277h-3.746l.833-.95.412-.474.834-.95h-8.253l-4.4 4.96h-8.2l5.878-6.649.222-.253c.464-.517 1.403-.95 2.09-.95h14.33v.011z","fill":"#FD0"}})])
          )
        }
      }
    